﻿import WebGLVectorLayerRenderer from 'ol/renderer/webgl/VectorLayer';
import Layer from 'ol/layer/Layer.js';

export default class WebGLLayer extends Layer {
    setCustomStyle(customStyle) {
        this.customStyle = customStyle;
    }

    createRenderer() {
        return new WebGLVectorLayerRenderer(this, {
            style: this.customStyle
        });
    }
}